/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Portuguese (Brazil)
export default {
  'fabric.editor.headingLink.ascSortingLabel': 'ascendente',
  'fabric.editor.headingLink.copied': 'Copiado!',
  'fabric.editor.headingLink.copyAnchorLink': 'Copiar link para cabeçalho',
  'fabric.editor.headingLink.copyAriaLabel': 'Copiar',
  'fabric.editor.headingLink.descSortingLabel': 'descendente',
  'fabric.editor.headingLink.failedToCopy': 'Falha na cópia',
  'fabric.editor.headingLink.noneSortingLabel': 'nenhum',
  'fabric.editor.inlineComment.marker.end': 'fim de comentário em linha',
  'fabric.editor.inlineComment.marker.start': 'início de comentário em linha',
};
